import { PropertyType, SubProduct } from "../types/subproduct";
import {
    ColumnGroup,
    ProductTable,
    TableColumn,
} from "../types/subproductTable";

export const emptySubProductColumnGroup: ColumnGroup = {
    name: {
        en: "",
        th: "",
    },
    columnSize: 1,
};

export const emptySubProductTable: ProductTable = {
    id: "",
    name: {
        en: "Empty Table",
        th: "ตารางเปล่า",
    },
    columnGroups: [],
    columns: [
        {
            accessor: "sku",
            type: PropertyType.Text,
            name: {
                en: "SKU",
                th: "SKU",
            },
        },
        {
            accessor: "name",
            type: PropertyType.Text,
            name: {
                en: "Name",
                th: "ชื่อ",
            },
        },
    ],
    rows: [],
    subProducts: {},
};

export const emptySubProductPropertyValue = {
    textProperty: {
        en: "",
        th: "",
    },
    fileDownloadProperty: "",
    imageProperty: "",
    promotionTagProperty: "",
};

export const emptyTextPropertyColumn: TableColumn = {
    accessor: "",
    type: PropertyType.Text,
    name: {
        en: "",
        th: "",
    },
};

export const emptySubProduct: SubProduct = {
    id: "",
    name: {
        en: "",
        th: "",
    },
    tags: [],
    properties: {},
};
